<script lang="ts" setup>
  import { useField } from 'vee-validate';
  import { computed, toRef } from 'vue';
  import DatePicker from './DatePicker.vue';
  import type { DatePickerProps } from './DatePicker.types';

  type DatePickerFieldProps = DatePickerProps & {
    rules?: (value: Date | undefined) => string | boolean;
  };

  const props = defineProps<DatePickerFieldProps>();

  const {
    value: fieldValue,
    errorMessage,
    handleChange,
    handleBlur,
    meta,
  } = useField<Date | undefined>(() => props.name, props.rules, {
    initialValue: props.startDate ? new Date(props.startDate) : undefined,
    label: toRef(props, 'label'),
  });

  const displayError = computed(() =>
    meta.touched ? errorMessage.value : undefined,
  );
</script>

<template>
  <DatePicker
    :id="id"
    :name="name"
    :label="label"
    :helper-text="helperText"
    :warning="warning"
    :placeholder="placeholder"
    :disabled="disabled"
    :disabled-reason="disabledReason"
    :required="required"
    :autofocus="autofocus"
    :teleport="teleport"
    :min-date="minDate"
    :max-date="maxDate"
    :start-date="startDate"
    :focus-start-date="focusStartDate"
    :prevent-min-max-navigation="preventMinMaxNavigation"
    :month-picker="monthPicker"
    :size="size"
    :model-value="fieldValue"
    :error="displayError"
    @update:model-value="handleChange"
    @blur="() => handleBlur()"
  />
</template>
